import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { ImportStatus } from './@types';

type GetExternalTrainingModuleImportProgressResponse = {
   sourceName: string;
   status: ImportStatus;
   value: null | number;
};

export async function getExternalTrainingModulesImportProgress(
   importId: number,
   common: CommonRequestOptions = {}
): Promise<GetExternalTrainingModuleImportProgressResponse> {
   return makeRequest('get', `/external-training-modules/imports/${importId}/progress`, common);
}
